// @mui
import {
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Table,
  TableContainer
} from '@mui/material';
// components
import Scrollbar from '@src/components/scrollbar';
// mock
import styled from '@emotion/styled';
import DataTableRow from '@src/components/data-table/data-row';
import Iconify from '@src/components/iconify';
import { TABLE_HEAD_RNG_DRAW_RESULT } from '@src/utils/mockdata/table-headers';
import _ from 'lodash';
import { useRaffleDrawContext } from '../provider';
import TableHeader from './table-header';
import TableRowItem from './table-row';

function ViewWinners() {
  const { viewWinners, setViewWinners } = useRaffleDrawContext();

  return (
    <BootstrapDialog
      open={!_.isEmpty(viewWinners)}
      maxWidth="md"
      onClose={() => setViewWinners(null)} 
      >
      <DialogTitle sx={{ m: 0, px: 4, pt: 3, borderBottom: 1, borderBottomColor: "#F1F5F9" }}>
        DRAW # {viewWinners?.raffle?.code} WINNERS
      </DialogTitle>
      <DialogContent>
        <ButtonClose onClick={() => setViewWinners(null)}>
          <Iconify  icon={'mdi:close'} width={25} />
        </ButtonClose>
        <Body />
      </DialogContent>
      <DialogActions sx={{alignItems: "center", justifyContent: "center", py: 3 }}>
        <StyledButtonCancel variant='outlined' onClick={() => setViewWinners(null)} >CLOSE</StyledButtonCancel>
      </DialogActions>
    </BootstrapDialog>
  );
}

const Body = () => {
  const { state, viewWinners, handleRequestSort } = useRaffleDrawContext();

  console.log("viewWinnersviewWinners", viewWinners)

  return (
    <Container disableGutters sx={{ mt: 1 }}>
      <Stack sx={{p: 2}}>
        <Scrollbar>
          <TableContainer>
            <Table>
              <TableHeader
                disableButton
                order={state.order}
                orderBy={state.orderBy}
                headLabel={TABLE_HEAD_RNG_DRAW_RESULT}
                onRequestSort={handleRequestSort}
              />
              <DataTableRow
                colSpan={7}
                headers={TABLE_HEAD_RNG_DRAW_RESULT}
                data={viewWinners?.winners ?? []}
                renderItem={({ item, index }: any) => {
                  return <TableRowItem 
                    key={`${index}`} {...item} 
                  />
                }} />
            </Table>
          </TableContainer>
        </Scrollbar>
      </Stack>
    </Container>
  );
}

export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    width: "100%",
    // height: 328,
    borderRadius: 20,
    margin: 0,
    padding: 0,
  },
}));

export const ButtonClose = styled(Button)(({ theme }) => ({
  width: 30, 
  height: 30,
  color: "#7D7D7D", 
  backgroundColor: "white", 
  position: "absolute",
  top: 20,
  right: 10,
}));

export const StyledButtonCancel = styled(Button)(({ theme }) => ({
  width: "70%",
  height: "50px",
  color: "black",
  border: "1px solid #E2E8F0"
}));

export default ViewWinners;
